export {
  PrayerEventEventMapPage as default,
  getStaticProps,
  getStaticPaths,
} from 'modules/event/pages/PrayerEventMap/PrayerEventMapPage'
